module.exports = __webpack_public_path__ + "static/media/insBanorte.a11a619d.svg";